import React, {useEffect, useState} from "react";
import {css} from "@panda/css";

import {ColumnDef, Table} from "@pg-design/table-module";
import {Text} from "@pg-design/text-module";
import {OfferType} from "@pg-rp/common-types";

import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {OfferDisplayType} from "../../../../offer/helpers/OfferDisplayType";
import {IVendorOfferWithoutVendorConfiguration} from "../../../../offer/types/VendorOffersListResponse";
import {useAppSelector} from "../../../../store/hooks";
import {useGetVendorDetailOffersQuery} from "../../../api/get_vendor_detail_offers";
import {VendorDetailActiveOffersPageSize} from "../../../constants/VendorDetailActiveOffersPageSize";
import {VendorDetailSoldOffersPageSize} from "../../../constants/VendorDetailSoldOffersPageSize";
import {IVendorDetail} from "../../../types/IVendorDetail";
import {convertToVendorDetailViewOffersPayload} from "../../../utils/convert_to_vendor_detail_view_offers_payload";

interface IProps {
    vendor: IVendorDetail;
    offersType: OfferDisplayType;
}

export const VendorDetailReportModalOffersTable = (props: IProps) => {
    const {vendor, offersType} = props;
    const [visibleOffers, setVisibleOffers] = useState<IVendorOfferWithoutVendorConfiguration[]>([]);
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const page = useAppSelector((state) =>
        offersType === OfferDisplayType.SOLD ? state.vendorDetailViewSlice.soldOffersListParams.page : state.vendorDetailViewSlice.activeOffersListParams.page
    );

    const fullQuery = {
        ...convertToVendorDetailViewOffersPayload({
            vendorId: vendor.id,
            region: null,
            displayType: offersType,
            pageSize: offersType === OfferDisplayType.SOLD ? VendorDetailSoldOffersPageSize : VendorDetailActiveOffersPageSize,
            type: [OfferType.FLAT, OfferType.HOUSE, OfferType.COMMERCIAL]
        }),
        page
    };
    const {data: offers} = useGetVendorDetailOffersQuery(fullQuery);

    useEffect(() => {
        if (offers?.results && page > 1) {
            setVisibleOffers((prevOffers) => [...prevOffers, ...offers.results]);
        }
        if (offers?.results && page === 1) {
            setVisibleOffers(offers.results);
        }
    }, [offers]);

    const columns: ColumnDef<IVendorOfferWithoutVendorConfiguration>[] = [
        {
            header: () => <Text variant="info_txt_2">Nazwa Inwestycji</Text>,
            accessorKey: "name",
            size: 200,
            cell: ({getValue}) => (
                <Text variant="info_txt_1" strong>
                    {getValue() as string}
                </Text>
            )
        },
        {
            header: () => <Text variant="info_txt_2">Miasto</Text>,
            accessorKey: "region.short_name",
            size: 120,
            cell: ({getValue}) => {
                const fullName = getValue() as string;
                const cityName = fullName?.split(",")[0] || "";
                return <Text variant="info_txt_1">{cityName}</Text>;
            }
        },
        ...(offersType !== OfferDisplayType.SOLD
            ? [
                  {
                      header: () => <Text variant="info_txt_2">Liczba dostępnych mieszkań</Text>,
                      accessorKey: "stats.properties_count_for_sale",
                      size: 120,
                      cell: ({getValue}: {getValue: () => unknown}) => <Text variant="info_txt_1">{getValue() as string}</Text>
                  }
              ]
            : []),
        {
            header: () => <Text variant="info_txt_2">Data rozpoczęcia</Text>,
            accessorKey: "construction_date_range.lower",
            size: 130,
            cell: ({getValue}) => {
                const dateValue = getValue() as string;
                const formattedDate = dateValue ? new Date(dateValue).toISOString().split("T")[0] : "";
                return <Text variant="info_txt_1">{formattedDate}</Text>;
            }
        },
        {
            header: () => <Text variant="info_txt_2">Data oddania</Text>,
            accessorKey: "construction_date_range.upper",
            size: 130,
            cell: ({getValue}) => {
                const dateValue = getValue() as string;
                const formattedDate = dateValue ? new Date(dateValue).toISOString().split("T")[0] : "";
                return <Text variant="info_txt_1">{formattedDate}</Text>;
            }
        },
        {
            header: () => <Text variant="info_txt_2">Oferta</Text>,
            accessorKey: "slug",
            size: 120,
            cell: ({row}) => {
                const offer = row.original;
                const offerLink = useOfferLink({
                    ...offer,
                    vendor: {slug: vendor.slug}
                });

                const handleClick = () => {
                    if (offerLink) {
                        window.open(offerLink, responsiveLinkTarget);
                    }
                };

                return (
                    <Text as="a" variant="info_txt_1" onClick={handleClick} className={css({textDecoration: "underline", cursor: "pointer"})}>
                        Zobacz ofertę
                    </Text>
                );
            }
        }
    ];

    const [columnVisibility, setColumnVisibility] = useState({});

    return (
        <Table
            data={visibleOffers || []}
            columns={columns}
            columnVisibility={columnVisibility}
            setColumnVisibility={setColumnVisibility}
            noDataText="Brak aktywnych ofert"
            className={tableStyle}
        />
    );
};

const tableStyle = css({
    border: "1px solid var(--colors-gray-500)",
    "& thead th": {
        borderBottom: "1px solid var(--colors-gray-500)"
    }
});
import React, {useEffect, useState} from "react";
import {css} from "@panda/css";

import {ColumnDef, Table} from "@pg-design/table-module";
import {Text} from "@pg-design/text-module";
import {OfferType} from "@pg-rp/common-types";

import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {OfferDisplayType} from "../../../../offer/helpers/OfferDisplayType";
import {IVendorOfferWithoutVendorConfiguration} from "../../../../offer/types/VendorOffersListResponse";
import {useAppSelector} from "../../../../store/hooks";
import {useGetVendorDetailOffersQuery} from "../../../api/get_vendor_detail_offers";
import {VendorDetailActiveOffersPageSize} from "../../../constants/VendorDetailActiveOffersPageSize";
import {VendorDetailSoldOffersPageSize} from "../../../constants/VendorDetailSoldOffersPageSize";
import {IVendorDetail} from "../../../types/IVendorDetail";
import {convertToVendorDetailViewOffersPayload} from "../../../utils/convert_to_vendor_detail_view_offers_payload";

interface IProps {
    vendor: IVendorDetail;
    offersType: OfferDisplayType;
}

export const VendorDetailReportModalOffersTable = (props: IProps) => {
    const {vendor, offersType} = props;
    const [visibleOffers, setVisibleOffers] = useState<IVendorOfferWithoutVendorConfiguration[]>([]);
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const page = useAppSelector((state) =>
        offersType === OfferDisplayType.SOLD ? state.vendorDetailViewSlice.soldOffersListParams.page : state.vendorDetailViewSlice.activeOffersListParams.page
    );

    const fullQuery = {
        ...convertToVendorDetailViewOffersPayload({
            vendorId: vendor.id,
            region: null,
            displayType: offersType,
            pageSize: offersType === OfferDisplayType.SOLD ? VendorDetailSoldOffersPageSize : VendorDetailActiveOffersPageSize,
            type: [OfferType.FLAT, OfferType.HOUSE, OfferType.COMMERCIAL]
        }),
        page
    };
    const {data: offers} = useGetVendorDetailOffersQuery(fullQuery);

    useEffect(() => {
        if (offers?.results && page > 1) {
            setVisibleOffers((prevOffers) => [...prevOffers, ...offers.results]);
        }
        if (offers?.results && page === 1) {
            setVisibleOffers(offers.results);
        }
    }, [offers]);

    const columns: ColumnDef<IVendorOfferWithoutVendorConfiguration>[] = [
        {
            header: () => <Text variant="info_txt_2">Nazwa Inwestycji</Text>,
            accessorKey: "name",
            size: 200,
            cell: ({getValue}) => (
                <Text variant="info_txt_1" strong>
                    {getValue() as string}
                </Text>
            )
        },
        {
            header: () => <Text variant="info_txt_2">Miasto</Text>,
            accessorKey: "region.short_name",
            size: 120,
            cell: ({getValue}) => {
                const fullName = getValue() as string;
                const cityName = fullName?.split(",")[0] || "";
                return <Text variant="info_txt_1">{cityName}</Text>;
            }
        },
        ...(offersType !== OfferDisplayType.SOLD
            ? [
                  {
                      header: () => <Text variant="info_txt_2">Liczba dostępnych mieszkań</Text>,
                      accessorKey: "stats.properties_count_for_sale",
                      size: 120,
                      cell: ({getValue}: {getValue: () => unknown}) => <Text variant="info_txt_1">{getValue() as string}</Text>
                  }
              ]
            : []),
        {
            header: () => <Text variant="info_txt_2">Data rozpoczęcia</Text>,
            accessorKey: "construction_date_range.lower",
            size: 130,
            cell: ({getValue}) => {
                const dateValue = getValue() as string;
                const formattedDate = dateValue ? new Date(dateValue).toISOString().split("T")[0] : "";
                return <Text variant="info_txt_1">{formattedDate}</Text>;
            }
        },
        {
            header: () => <Text variant="info_txt_2">Data oddania</Text>,
            accessorKey: "construction_date_range.upper",
            size: 130,
            cell: ({getValue}) => {
                const dateValue = getValue() as string;
                const formattedDate = dateValue ? new Date(dateValue).toISOString().split("T")[0] : "";
                return <Text variant="info_txt_1">{formattedDate}</Text>;
            }
        },
        {
            header: () => <Text variant="info_txt_2">Oferta</Text>,
            accessorKey: "slug",
            size: 120,
            cell: ({row}) => {
                const offer = row.original;
                const offerLink = useOfferLink({
                    ...offer,
                    vendor: {slug: vendor.slug}
                });

                const handleClick = () => {
                    if (offerLink) {
                        window.open(offerLink, responsiveLinkTarget);
                    }
                };

                return (
                    <Text as="a" variant="info_txt_1" onClick={handleClick} className={css({textDecoration: "underline", cursor: "pointer"})}>
                        Zobacz ofertę
                    </Text>
                );
            }
        }
    ];

    const [columnVisibility, setColumnVisibility] = useState({});

    return (
        <Table
            data={visibleOffers || []}
            columns={columns}
            columnVisibility={columnVisibility}
            setColumnVisibility={setColumnVisibility}
            noDataText="Brak aktywnych ofert"
            className={tableStyle}
        />
    );
};

const tableStyle = css({
    border: "1px solid var(--colors-gray-500)",
    "& thead th": {
        borderBottom: "1px solid var(--colors-gray-500)"
    }
});
